<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/config/custom/table/fields/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('kehu')">
            <yi_data_select :type="'customer'" :ids.sync="yt.conditions.customerId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('qianduanbiaodanbiaoshima')">
            <el-input v-model="yt.conditions.tableId"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{$t('sousuo')}}
            </el-button>
            <el-button @click="yt.clear()">{{$t('chongzhi')}}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1', beforeAdd);setAddEnable()" type="primary">
          {{$t('xinzeng')}}
        </el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row,'w1')">{{$t('bianji')}}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger"
                       @click="yt.remove(scope.row,'/web/config/custom/table/fields/delete')">
              {{$t('shanchu')}}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
               :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <template>
        <el-form :inline="true" ref="form" size="mini" :label-width="'157px'">
          <el-form-item :label="$t('qianduanbiaodanbiaoshima')" required>
            <el-input v-model="yt.editObj.tableId"></el-input>
          </el-form-item>
          <el-form-item :label="$t('kehu')" required>
            <yi_data_select :type="'customer'" :ids.sync="yt.editObj.customerId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('kehudingzhihuaziduanxinxi')" required>
            <el-input type="textarea" :rows="4" placeholder="请把json压缩为一行" v-model="yt.editObj.fieldsJson"></el-input>
          </el-form-item>
          <el-form-item :label="$t('beizhu')" required>
            <el-input v-model="yt.editObj.remark"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini" v-if="yt.editObj.action == 'xinzeng'"
                     @click="yt.req('POST','/web/config/custom/table/fields/create')" type="primary">
						{{$t('baocun')}}
					</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" v-if="yt.editObj.action == 'bianji'"
                     @click="yt.req('POST','/web/config/custom/table/fields/update')" type="primary">
            {{$t('baocun')}}
          </el-button>
				</span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "admin_global_custom_table_fields_list",
  data() {
    return {
      columns: [{
        label: 'qianduanbiaodanbiaoshima',
        prop: 'tableId',
      }, {
        label: 'kehumingcheng',
        prop: 'customer.name',
      }, {
        label: 'kehudingzhihuaziduanxinxi',
        prop: 'fieldsJson',
      }, {
        label: 'beizhu',
        prop: 'remark',
        width: 250,
      }, {
        label: 'caozuo',
        type: 'slot',
        width: 150,
        fixed: 'right'
      }]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {

      };
      this.yt.get(1);
    }, 300);
  },
  methods: {
    beforeSaveReq(){
      console.log(this.yt.editObj);
    }
  },
}
</script>

<style scoped="scoped" lang="scss"></style>